import { useQuery } from '@hooks/reactQuery';

import { getAlreadyPickedDatesForRequest } from '@api/assetCartRequest';

import { requestCartPickedDatesFormatted } from '@utils/formatter';

import { RENT_REQUESTS_PICKED_DATES } from '@constants/queryKeys';

export const useRentRequestsDatesPicked = (assetDbId: string) => {
	const {
		data,
		isLoading: isLoadingDatesPicked,
		isFetching: isFetchingDatesPicked,
	} = useQuery({
		queryKey: [RENT_REQUESTS_PICKED_DATES],
		queryFn: () => getAlreadyPickedDatesForRequest(assetDbId),
		select: pickedDates => requestCartPickedDatesFormatted(pickedDates?.dates[0]?.ranges),
		enabled: [!!assetDbId],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingRentRequestsDatesPicked: isLoadingDatesPicked || isFetchingDatesPicked,
		rentRequestsDatesPicked: data || [],
	};
};
